import { Routes, Route, BrowserRouter } from 'react-router-dom';

import { routes } from './routes';

import Header from 'components/header';
import Footer from 'components/footer';
import { WithCountryBlacklist } from 'hoc';

const MainRouter = () => { // TODO move geofencing logic to suite
  return (
    <>
      <Header />
      <WithCountryBlacklist>
        <Routes>
          {routes.map((data, index) => {
            return (
              <Route
                // @ts-expect-error
                onUpdate={() => window.scrollTo(0, 0)}
                exact={true}
                path={data.path}
                element={data.component}
                key={index}
              />
            );
          })}
        </Routes>
      </WithCountryBlacklist>
      <Footer />
    </>
  );
};

export default MainRouter;
export { routes };
